import { render } from "./PlanPickerWizard.vue?vue&type=template&id=555bb267&scoped=true"
import script from "./PlanPickerWizard.vue?vue&type=script&lang=js"
export * from "./PlanPickerWizard.vue?vue&type=script&lang=js"

import "./PlanPickerWizard.vue?vue&type=style&index=0&id=555bb267&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555bb267"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
